import React, { useState } from 'react';
import { Mail, Lock, Eye, EyeOff, Loader2 } from 'lucide-react'; // Added Loader icon
import { useApp } from '../context/AppContext';
import Layout from './Layout';

const Login = ({ onLogin }) => {
  const { setUser } = useApp();
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    setLoading(true);

    try {
      const response = await fetch('https://companylocker.com/admin/wp-json/dpt/v1/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: email, // Your PHP code looks for 'username'
          password: pass,
        }),
      });

      const data = await response.json();
      console.log(response)
      if (response.ok && data.success) {
        // Map the API response to your AppContext user object
        setUser({
          id: data.user_id,
          email: data.email,
          displayName: data.display_name,
          role: 'Contributor',
        });
        
        onLogin();
      } else {
        // Handle custom errors from your PHP (e.g., 'not_approved' or 'login_failed')
        setError(data.message || 'Invalid credentials or account not approved.');
      }
    } catch (err) {
      setError('Connection error. Please check your internet.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="pt-20 pb-12 text-center flex flex-col items-center">
        <img
          src="https://clubparadiseac.com/cdn/shop/files/logo_rect_white.png?v=1752483545&width=225"
          className="h-10 mb-8 opacity-40 grayscale"
          alt="Logo"
        />
        <h2 className="text-4xl font-black mb-2 tracking-tighter">Welcome</h2>
        <p className="text-gray-500 font-medium">Sign in to continue</p>
      </div>

      <div className="space-y-4">
        {error && (
          <div className="bg-red-500/10 text-red-500 p-4 rounded-2xl text-xs font-bold border border-red-500/20">
            {error}
          </div>
        )}

        <div className="bg-white/5 border border-white/10 rounded-2xl flex items-center px-4 py-4 focus-within:border-purple-500 transition-all">
          <Mail size={20} className="text-gray-500 mr-3" />
          <input
            className="bg-transparent outline-none flex-1 text-base font-bold text-white"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl flex items-center px-4 py-4 focus-within:border-purple-500 transition-all">
          <Lock size={20} className="text-gray-500 mr-3" />
          <input
            type={show ? 'text' : 'password'}
            className="bg-transparent outline-none flex-1 text-base font-bold text-white"
            placeholder="Password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            disabled={loading}
          />
          <button onClick={() => setShow(!show)} className="text-gray-500">
            {show ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full bg-gradient-to-r from-purple-600 to-pink-600 py-5 rounded-2xl font-black text-xs tracking-widest mt-6 shadow-lg shadow-purple-500/20 active:scale-95 transition-all flex justify-center items-center"
        >
          {loading ? (
            <Loader2 className="animate-spin" size={18} />
          ) : (
            'SIGN IN'
          )}
        </button>
      </div>
    </Layout>
  );
};

export default Login;